<template>
  <div class="container">
    <div class="box_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="'https://www.hidisp.cn/account/login?v='+Math.round(Math.random()*10000)"
        style="width:100%;height:100%;overflow: hidden;"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
     <!-- :src="'../../../static/message/login.html?u='+$store.state.user.account.information_account+'&p='+$store.state.user.account.information_password" -->
      <div class="message_user" v-if="message_vibilty">
          <div class="message_user_box">
            账号：<span>{{$store.state.user.account.information_account}}</span><br/>
            密码：<span>{{$store.state.user.account.information_password}}</span>
            <div class="close_mess" @click="message_vibilty = false"><i class="el-icon-close"></i></div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      title: '',
      message_vibilty:true
    }
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  height:100%;
  background:url('../../assets/datacount.png') no-repeat;
  background-size: cover;
  
}

.box_main{
  position: absolute;
  top:-52px;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeContain{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
.message_user{
  width:200px;
  height:200px;
  position:absolute;
  background: #fff;
  left:50%;
  top:200px;
  padding: 24px 35px;
  margin-left: -100px;
  border-radius: 10px;
  box-sizing: 0 0 10px rgba(0,0,0,.3);
  .message_user_box{
    width:100%;
    height:100%;
    position: relative;
    color:#999;
    font-size:18px;
    line-height: 2;
    .close_mess{
      position:absolute;
      display: flex;
      align-items: center;
      justify-content: center; /* 水平均匀分布 */
      width:24px;
      height:24px;
      background: #3b8cff;
      border-radius: 24px;
      right:-20px;
      top:-10px;
      color:#fff;
      cursor: pointer;
    }
    span{
      color:#3b8cff;
    }
  }
}
</style>